var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('Page_list',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.isShowList),expression:"$route.meta.isShowList"}]}),_c('fixed',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.isShowList),expression:"$route.meta.isShowList"}],attrs:{"page":'Page_list'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }